Vue.component('adminQuestLine', {
  template: templates.adminQuestLine,
  data() {
    return {
      model: {
          edit: false,
          quest:{
              name: null,
              description: null,
              cards:[{ cardId: null, tier: 0 }],
              date: null,
              time: null,
              level: 0,
              card_amount: 0,
              selectedMode: null,
              wins: 0,
              rewards: {
                xp: 0,
                barks: 0,
                givePack: [{ packId: null, packs_quantity: 0 }],
                randomCard: [{ randomCard: 0, random_amount: 0 }],
                rewardFrames: [],
                rewardFrameMode: 'single-frame',
                packs_amount: 0,
                random_amount: 0,
              },
          },
          expandedRow: '',
          cards: {},
          quests: [],
          selectedQuest: {},
          randomcard: [
            {
              name: ''
            },
            {
              name: 'Standard Card'
            },
            {
              name: 'Ultra Card'
            },
            {
              name: 'Legendary Card'
            },
            {
              name: 'Ultimate Card'
            },
            {
              name: 'Bone Card'
            },  
            {
              name: 'Ascension Card'
            } 
          ],
          packs: {},
          frames: {},
          backgrounds: {},
          cardBacks: {}
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
    c.getPack();
    c.getFrames();
    c.getBackgrounds();
    c.getCardBacks();
    c.connect();
  },
  methods: {
      connect() {
        const c = this;
        c.ws = new WebSocket(utils.getWsUrl());
  
        c.ws.onmessage = (event) => {
          const messageData = event.data;
          try {
            const parsedData = JSON.parse(messageData);
            // Handle parsed data as needed
          } catch (error) {
            console.error('Error parsing message data:', error);
          }
        };
  
        c.ws.onopen = () => {
          console.log('WebSocket connection established');
        };
  
        c.ws.onclose = () => {
          console.log('WebSocket connection closed');
        };
      },
      
      add() {
          const c = this;
          c.model.edit = true;
          c.getCards()
      },
      
      get() {
        const c = this;
        let data = {};
  
        questLineService.get()
        .then(function (response) {
          for (let d of response.data) {
            // Ensure rewards structure exists - THIS IS THE KEY FIX
            if (!d.rewards) {
              d.rewards = {
                xp: d.xp || 0,
                barks: d.barks || 0,
                givePack: d.packs || [{ packId: null, packs_quantity: 0 }],
                randomCard: d.otherReward || [{ randomCard: 0, random_amount: 0 }],
                packs_amount: 0,
                random_amount: 0,
              };
            }
            // Ensure cards array exists
            if (!d.cards) {
              d.cards = [];
            }
            d.image = [`${d.id}.png`];
            data[`${d.id}`] = d;
          }
          c.model.quests = data;
          c.getCards();
        })
        .catch(function (response){
          // console.log(response)
        })
      },
      
      getCards() {
        const c = this;
        let data = {};

        cardService.get()
          .then(function (response) {
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.cards = data;
          })
          .catch(function (error) {
            //console.log(error);
          });
      },
      
      // Handle  form changes
      handleQuestChange(data) {
          const c = this;
          // Handle nested quest object properly
          if (data.model) {
              // Deep merge to preserve existing properties
              Object.keys(data.model).forEach(key => {
                  if (Array.isArray(data.model[key])) {
                      c.model.quest[key] = [...data.model[key]];
                  } else if (typeof data.model[key] === 'object' && data.model[key] !== null) {
                      c.model.quest[key] = { ...c.model.quest[key], ...data.model[key] };
                  } else {
                      c.model.quest[key] = data.model[key];
                  }
              });
          } else {
              // Handle direct property updates
              Object.keys(data).forEach(key => {
                  if (Array.isArray(data[key])) {
                      c.model.quest[key] = [...data[key]];
                  } else if (typeof data[key] === 'object' && data[key] !== null) {
                      c.model.quest[key] = { ...c.model.quest[key], ...data[key] };
                  } else {
                      c.model.quest[key] = data[key];
                  }
              });
          }
      },
      
      // Handle reward changes - now updates model.quest.rewards
      handleRewardChange(rewardData) {
          const c = this;
          c.model.quest.rewards = { ...c.model.quest.rewards, ...rewardData };
      },
      
      save(){
        const c = this;
        const data = c.model.quest;

        if (!data.name) {
          utils.alert.error('Quest name is required');
          return;
        }

        if (!data.description) {
          utils.alert.error('Quest Rule is required');
          return;
        }

        for(i=0;i<data.cards.length;i++){

          if(!data.cards[i].cardId){
            utils.alert.error('Select a card');
            return;
          }
        
          if(data.cards[0].tier < 1){
            utils.alert.error('Card tier must be greater than 1');
            return;
          }

        }

        if (!data.date) {
          utils.alert.error('Date is required');
          return;
        }

        if (!data.time) {
          utils.alert.error('Time is required');
          return;
        }
        
        if (!data.selectedMode) {
          utils.alert.error('select mode');
          return;
        }

        if (data.wins === 0) {
          utils.alert.error('wins must be greater than 1');
          return;
        }

        // Updated validation to use rewards structure
        const hasRewards = data.rewards.xp > 0 || 
                         data.rewards.barks > 0 || 
                         (data.rewards.givePack && data.rewards.givePack[0] && data.rewards.givePack[0].packId) ||
                         (data.rewards.randomCard && data.rewards.randomCard[0] && data.rewards.randomCard[0].randomCard > 0);

        if(!hasRewards){
          utils.alert.error('Give atleast 1 reward');
          return;
        }

        questLineService.save(data)
        .then(function (response) {
          const questId = response.data?.id || data.id;

          // Save reward frames/backgrounds if any are selected
          if (data.rewards.rewardFrames && data.rewards.rewardFrames.length > 0) {
            c.saveQuestRewardFrames(questId, data.rewards.rewardFrames);
          }

          // c.reset();
          c.get();
          const messageData = {
            status: 'quest',
          };

          c.ws.send(JSON.stringify(messageData));
          utils.alert.success('Saved!');

        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });
      },
      
      edit(id) {
        const c = this;
        let data = c.model.quests[`${id}`];

        if (id == c.model.quests.id) {
          c.model.edit = false;
        } else {
          c.model.edit = true;
        }

        // Ensure rewards structure exists before editing
        if (!data.rewards) {
          data.rewards = {
            xp: data.xp || 0,
            barks: data.barks || 0,
            givePack: data.packs || [{ packId: null, packs_quantity: 0 }],
            randomCard: data.otherReward || [{ randomCard: 0, random_amount: 0 }],
            packs_amount: 0,
            random_amount: 0,
          };
        }

        // Handle backward compatibility - convert old structure to new rewards structure
        if (!data.rewards.givePack && data.packs) {
          data.rewards.givePack = data.packs.length === 0 ? [{ packId: null, packs_quantity: 0 }] : data.packs;
        }

        if (!data.rewards.randomCard && data.otherReward) {
          data.rewards.randomCard = data.otherReward.length === 0 ? [{ randomCard: 0, random_amount: 0 }] : data.otherReward;
        }

        // Ensure arrays exist
        if (!data.rewards.givePack) {
          data.rewards.givePack = [{ packId: null, packs_quantity: 0 }];
        }

        if (!data.rewards.randomCard) {
          data.rewards.randomCard = [{ randomCard: 0, random_amount: 0 }];
        }

        // Ensure cards array exists
        if (!data.cards) {
          data.cards = [];
        }

        // Initialize rewardFrames - preserve any existing stored frames/backgrounds
        // These will be overridden if frames are found in adminRewardFrames
        if (!data.rewards.rewardFrames) {
          data.rewards.rewardFrames = [];
        }
        if (!data.rewards.rewardFrameMode) {
          data.rewards.rewardFrameMode = 'single-frame';
        }

        c.model.quest = data

        // Load linked reward frames/backgrounds from adminRewardFrames
        // This will update c.model.quest.rewards.rewardFrames with linked items
        c.loadQuestRewardFrames(id);
      },
      
      reset(){
        const c = this;
        c.model.edit = false;
        c.model.quest = {
          name: null,
          description: null,
          cards:[{ cardId: null, tier: 0 }],
          date: null,
          time: null,
          level: 0,
          card_amount: 0,
          selectedMode: null,
          wins: 0,
          rewards: {
            xp: 0,
            barks: 0,
            givePack: [{ packId: null, packs_quantity: 0 }],
            randomCard: [{ randomCard: 0, random_amount: 0 }],
            rewardFrames: [],
            rewardFrameMode: 'single-frame',
            packs_amount: 0,
            random_amount: 0,
          }
        }
      },
      
      getPack(){
        const c = this;
        let data = {};

        packService.get()
          .then(function (response) {
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.packs = data;
          })
          .catch(function (error) {
            //console.log(error);
          });
      },

      getFrames(){
        const c = this;
        let data = {};

        frameService.get()
          .then(function (response) {
            for (let d of response.data) {
              d.frameImage = d.uploaded && d.extension
                ? `${root}/images/frames/${d.id}/${d.id}.${d.extension}?t=${Date.now()}`
                : null;
              data[`${d.id}`] = d;
            }
            c.model.frames = data;
          })
          .catch(function (error) {
            console.error('Error loading frames:', error);
          });
      },

      getBackgrounds(){
        const c = this;
        let data = {};

        backgroundService.get()
          .then(function (response) {
            for (let d of response.data) {
              d.backgroundImage = d.extension
                ? `${root}/images/backgrounds/${d.id}/${d.id}.${d.extension}?t=${Date.now()}`
                : null;
              data[`${d.id}`] = d;
            }
            c.model.backgrounds = data;
          })
          .catch(function (error) {
            console.error('Error loading backgrounds:', error);
          });
      },

      getCardBacks(){
        const c = this;
        let data = {};

        cardBackService.get()
          .then(function (response) {
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.cardBacks = data;
          })
          .catch(function (error) {
            console.error('Error loading card backs:', error);
          });
      },

      loadQuestRewardFrames(questId){
        const c = this;

        // Load all reward frames for quest type, then filter by quest_id
        rewardFrameService.get({ reward_type: 'quest' })
          .then(function (response) {
            if (!response.success) {
              console.error('Failed to load reward frames');
              return;
            }

            // Filter frames linked to this specific quest
            const linkedFrames = (response.data || []).filter(r => r.quest_id == questId);
            const frameRewards = linkedFrames.map(r => ({ id: r.frame_id, type: 'frame' }));

            // Load all reward backgrounds for quest type
            return rewardBackgroundService.get({ reward_type: 'quest' })
              .then(function (bgResponse) {

                if (!bgResponse.success) {
                  console.error('Failed to load reward backgrounds');
                  return;
                }

                // Filter backgrounds linked to this specific quest
                const linkedBackgrounds = (bgResponse.data || []).filter(r => r.quest_id == questId);
                const backgroundRewards = linkedBackgrounds.map(r => ({ id: r.background_id, type: 'background' }));
        
                // Combine both and update the quest rewards
                const combinedRewards = [...frameRewards, ...backgroundRewards];

                if (combinedRewards.length > 0) {
                  // Determine mode based on count and types
                  let mode = 'single-frame';
                  if (combinedRewards.length === 1) {
                    mode = combinedRewards[0].type === 'frame' ? 'single-frame' : 'single-background';
                  } else {
                    mode = 'multiple';
                  }

                  const updatedRewards = {
                    ...c.model.quest.rewards,
                    rewardFrames: combinedRewards,
                    rewardFrameMode: mode
                  };

                  Vue.set(c.model.quest, 'rewards', updatedRewards);

                } else {
                  console.log('No linked frames/backgrounds found for quest:', questId);
                }
              });
          })
          .catch(function (error) {
            console.error('Error loading quest reward frames/backgrounds:', error);
          });
      },

      saveQuestRewardFrames(questId, rewardFrames){
        console.log('Saving reward frames for quest:', questId, rewardFrames);

        // First, load existing frames/backgrounds to delete them
        Promise.all([
          rewardFrameService.get({ reward_type: 'quest' }),
          rewardBackgroundService.get({ reward_type: 'quest' })
        ]).then(function([frameResponse, bgResponse]) {
          console.log('Fetched existing frames:', frameResponse);
          console.log('Fetched existing backgrounds:', bgResponse);

          // Find existing frames/backgrounds for this quest
          const existingFrames = (frameResponse.data || []).filter(r => r.quest_id == questId);
          const existingBackgrounds = (bgResponse.data || []).filter(r => r.quest_id == questId);

          console.log('Existing frames for this quest:', existingFrames);
          console.log('Existing backgrounds for this quest:', existingBackgrounds);

          // Delete existing frames
          const deletePromises = [];
          existingFrames.forEach(frame => {
            console.log('Deleting quest frame:', frame.id);
            deletePromises.push(
              rewardFrameService.delete(frame.id)
                .then(res => console.log('Deleted quest frame:', frame.id, res))
                .catch(err => console.error('Error deleting quest frame:', frame.id, err))
            );
          });
          existingBackgrounds.forEach(bg => {
            console.log('Deleting quest background:', bg.id);
            deletePromises.push(
              rewardBackgroundService.delete(bg.id)
                .then(res => console.log('Deleted quest background:', bg.id, res))
                .catch(err => console.error('Error deleting quest background:', bg.id, err))
            );
          });

          // Wait for all deletions to complete, then save new ones
          return Promise.all(deletePromises);
        }).then(function() {
          // Separate frames and backgrounds
          const frames = rewardFrames.filter(r => r.type === 'frame');
          const backgrounds = rewardFrames.filter(r => r.type === 'background');

          // Save each frame
          const savePromises = [];
          frames.forEach(frame => {
            const frameData = {
              frame_id: frame.id,
              quest_id: questId,
              reward_type: 'quest',
              unlock_type: 'frame',
              is_active: true,
              is_guaranteed: true
            };

            savePromises.push(
              rewardFrameService.save(frameData)
                .then(function(response) {
                  console.log('Saved reward frame:', response);
                })
                .catch(function(error) {
                  console.error('Error saving reward frame:', error);
                })
            );
          });

          // Save each background
          backgrounds.forEach(background => {
            const backgroundData = {
              background_id: background.id,
              quest_id: questId,
              reward_type: 'quest',
              is_active: true,
              is_guaranteed: true
            };

            savePromises.push(
              rewardBackgroundService.save(backgroundData)
                .then(function(response) {
                  console.log('Saved reward background:', response);
                })
                .catch(function(error) {
                  console.error('Error saving reward background:', error);
                })
            );
          });

          return Promise.all(savePromises);
        }).then(function() {
          console.log('All quest reward frames/backgrounds saved successfully');
        }).catch(function(error) {
          console.error('Error in saveQuestRewardFrames:', error);
        });
      },

      formattedDate(questDate) {
        const date = new Date(questDate);
        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate();
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
      },
      
      toggleDetails(index) {
        const c = this;
        c.model.expandedRow = c.model.expandedRow === index ? null : index;
      },
      
      // Card management methods
      generateCards() {
        this.model.quest.cards = Array.from({ length: this.model.quest.card_amount }, (_, index) => ({
          cardId: null,
          tier: 0,
        }));
      },
      
      incrementCards(){
        const c = this;
        c.model.quest.card_amount++
        c.model.quest.cards.push({ cardId: null, tier: 0 });
      },
      
      removeCard(index){
        if (this.model.quest.card_amount > 0) {
          this.model.quest.card_amount--;
          this.model.quest.cards.splice(index, 1);
        }
      },
      
      // Pack management methods (for rewards)
      incrementPack(){
        const c = this;
        c.model.quest.rewards.packs_amount++
        c.model.quest.rewards.givePack.push({ packId: null, packs_quantity: 0 });
      },
      
      removePack(index) {
        if (this.model.quest.rewards.packs_amount > 0) {
          this.model.quest.rewards.packs_amount--;
          this.model.quest.rewards.givePack.splice(index, 1);
        }
      },
      
      // Random card management methods (for rewards)
      incrementRandomCards(){
        const c = this;
        c.model.quest.rewards.random_amount++
        c.model.quest.rewards.randomCard.push({ randomCard: 0, random_amount: 0 });
      },
      
      removeRandomCard(index){
        if (this.model.quest.rewards.random_amount > 0) {
          this.model.quest.rewards.random_amount--;
          this.model.quest.rewards.randomCard.splice(index, 1);
        }
      },
      handleCardImageUpload(data){
      const c = this;
      c.model.quest.image = [`${data.id}.png`]
      c.model.quest[`${data.id}`].image = [`${data.id}.png`]
      c.refreshImage();
      
      
    },
    
    getQuestUrl(){
      const c = this;
      const url = `${root}/images/quest/`;
      return url;
      },
    refreshImage() {
      const c = this;
      const imageUrl = `${c.getCardUrl()}${c.model.quest.image}`;
      
      c.checkImageExists(imageUrl).then(exists => {
        if (!exists) {
          c.model.quest.image = null; 
          c.model.quest[`${c.model.quest.id}`].image = null
        }
      });
    },
    checkImageExists(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = url;
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
      });
    },
    removeCurrentFile(data){
      const c = this;

      const id = c.model.quest.id
      uploadService.deleteFile('quest', id, data.image)
      .then(function (response) {

        c.model.quest.image = null;
        utils.alert.success('File Removed!');
      })
      .catch(function (error) {
        utils.alert.error(error);
      });
    },
  }
});